export const ROLE_LABELS: Record<string, string> = {
  owner: 'Propietario',
  editor: 'Editor',
  analyst: 'Analista',
  viewer: 'Visualizador',
};

/**
 * La API devuelve los nombres de rol en inglés (`Owner`, `Analyst`, `Viewer`...).
 * El backoffice los muestra en español; los roles sin traducción definida
 * (p. ej. `SuperAdmin`) se devuelven tal cual para no ocultar información.
 */
export function getRoleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return ROLE_LABELS[role.trim().toLowerCase()] ?? role;
}
